<template>
	<!-- 订单核销 -->
	<div>
		<cube-page type="myorder-view" title="核销">
			<div slot="content">
				<div v-if="orderObj">
					<van-sticky :offset-top="44">
						<div class="stck-q wf_div">
							<div class="wf_name_div">
								<div class="wf_name">
									<van-icon name="coupon-o" size="24" />
									<div class="n-title">{{orderObj.goods_name}}</div>
								</div>
								<div class="btn-hx">
									<div class="zdy-btn" @click="isPl= !isPl">
										批量核销
									</div>
								</div>
							</div>
							<div class="cell-box cell-box-h">
								<div class="left-name">
									<div class="row">
										<div class="col">
											<div class="name">
												总编号:
											</div>
											<div class="nr">
												{{orderObj.order_no}}
											</div>
										</div>
									</div>
									<div class="row">
										<div class="col">
											<div class="name">
												数量:
											</div>
											<div class="nr">
												{{orderObj.number}}
											</div>
										</div>
									</div>
									<div class="row">
										<div class="col">
											<div class="name">
												日期:
											</div>
											<div class="nr">
												{{orderObj.use_date}}
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</van-sticky>
					<van-list v-model="loading" :finished="finished" finished-text="没有更多了" :immediate-check="false"
						@load="onLoad" class="wf_div list-div">
					<!-- <div v-if="dataList.length>0" class="wf_div list-div"> -->
						<van-checkbox-group v-model="result" ref="checkboxGroup" @change="checksChange">
							<div class="cell-box" v-for="item in dataList"
								:class="result.indexOf(item.id) != -1?'cell-box-active':''">
								<van-checkbox :name="item.id" class="check-q" v-if="isPl" :disabled = "item.use_status != '10'"></van-checkbox>
								<div class="left-name">
									<div class="row">
										<div class="col">
											<div class="name">
												姓名:
											</div>
											<div class="nr">
												{{item.contacts}}
											</div>
										</div>
									</div>
									<div class="row">
										<div class="col">
											<div class="name">
												身份证
											</div>
											<div class="nr">
												{{item.IDCard}}
											</div>
										</div>
									</div>
									<div class="row">
										<div class="col">
											<div class="name">
												核销编码:
											</div>
											<div class="nr">
												{{item.code}}
											</div>
										</div>
									</div>
									<div class="row">
										<div class="col">
											<div class="name">
												状态
											</div>
											<div class="nr">
												{{item.status_text}}
											</div>
										</div>
									</div>
								</div>
								<div class="right-btn">
                  <div class="zdy-btn" v-if="item.use_status=='10'" @click="onHx(item.id)">
										核销
									</div>
								</div>
							</div>
						</van-checkbox-group>
					<!-- </div> -->
					</van-list>
					<div class="fid-fo" v-if="isPl">
						<div class="footer-btns">
							<van-checkbox v-model="checkedall" @click="checkAll">全选</van-checkbox>
							<van-button @click="onHx(null)" type="info" round :disabled="result.length == 0">
								一键核销
							</van-button>
						</div>
					</div>
				</div>
			</div>
		</cube-page>
		<cube-view></cube-view>
	</div>
</template>

<script>
	import {
		Toast
	} from 'vant';
	import CubeView from '@/components/TP/cube-view'
	import CubePage from '@/components/TP/cube-page.vue'
	import * as util from '@/utils/network'
	import wx from 'weixin-js-sdk'

	export default {
		components: {
			CubePage,
			CubeView,
		},
		data() {
			return {
				loading: false,
				finished: false,
				isNoData: false,
				pageIndex: 1,
				pageTotal: 5,
				isPl: false,
				result: [],
				checkedall: false,
				dataList: [],
				orderObj: null
			}
		},
		created() {
			this.getData()
		},
		methods: {
			//核销操作
			onHx(id){
				let that = this;
				var url = "/addons/litestore/api.supplier/wiped"
				var ids=[]
				if(id){
					ids.push(id)
				}
				let param = {
					order_id: that.orderObj.order_id,
					ids:ids.length>0?ids:that.result
				}
				console.log(param)
				//这里直接调用网络接口
				util.post(url, param,function(result) {

					if(result.code==1){
					  console.log(result.msg)
            that.$toast.success({
              message:result.msg,
              duration:800,
              onClose:function () {
                location.reload();
              }
            });
					}
				});

			},
			checksChange() {
				let that = this
				if (that.result.length == that.pageTotal && that.pageTotal > 0) {
					that.checkedall = true;
				}
			},
			checkAll(e) {
				//this.$refs.checkboxGroup.toggleAll(this.checkedall);
				this.$refs.checkboxGroup.toggleAll({
          skipDisabled: true,
        });
			},
			onLoad() {
				let that = this
				// 异步更新数据
				that.pageIndex++;
				setTimeout(() => {
					that.getData();
				}, 1000)
			},
			getData() {
				let that = this;
				var url = "/addons/litestore/api.supplier/getTravelList"
				let param = {
					code: that.$route.query.code,
          page : that.pageIndex,
				}
				//这里直接调用网络接口
				util.post(url, param,
					function(result) {
						let data = result.data
						if(!that.orderObj){
							that.orderObj = data.order
						}
						//that.dataList = data.metas
						that.loading = false;
						//这里对状态 进行分类
						that.pageTotal = data.total
						if (that.pageTotal < 1) {
							that.isNoData = true
							return;
						}
						if (!data.metas) {
              console.log(222)
							// 加载结束
							that.finished = true;
							return;
						}

						// 将新数据与老数据进行合并
						that.dataList = that.dataList.concat(data.metas);
						//如果列表数据条数>=总条数，不再触发滚动加载
						if (that.dataList.length >= that.pageTotal) {
						  console.log(111)
							that.finished = true;
						}
					},
				);

			}
		}
	}
</script>
<style>

</style>
<style type="text/css" lang="less">
	.stck-q {
		padding: 15px;
		background-color: #fff;
		box-shadow: 1px 3px 5px #dedede;
	}

	.wf_div {
		// padding: 15px 15px 50px;
		font-size: 14px;
		font-weight: 600;
	}

	.zdy-btn {
		padding: 2px 5px;
		border-radius: 5px;
		text-align: center;
		color: #fff;
		background-color: #00b7eb;
	}

	.wf_name_div {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding-bottom: 15px;

		.btn-hx {
			padding: 0 !important;
			width: 70px;
			border-radius: 5px;
		}

		.wf_name {
			flex: 1;
			display: flex;
			align-items: center;

			.n-title {
				padding: 0 10px;
				font-size: 16px;
			}

			.van-icon {
				font-weight: 600;
				color: #787878;
			}
		}
	}

	.list-div {
		padding-bottom: 50px;
	}

	.cell-box {
		margin-top: 3px;
		padding: 5px 10px;
		display: flex;
		align-items: center;
		font-size: 13px;
		border-top: 1px solid #eeeeee;

		.check-q {
			width: 25px;
		}

		.left-name {
			flex: 1;
			padding: 0 10px;

			.row {
				display: flex;
				line-height: 25px;

				.col {
					display: flex;

					.name {
						width: 80px;
					}

					.nr {
						flex: 1;
					}
				}
			}
		}

		.right-btn {
			width: 40px;
			font-weight: 500;
		}
	}

	.cell-box-h {
		margin-top: 0px;
		padding: 0px;
		padding-top: 10px;
		display: flex;
		align-items: center;
	}

	.cell-box-active {
		border-bottom: 1px solid #00b7eb;
	}

	.fid-fo {
		position: fixed;
		bottom: 0;
		left: 0;
		right: 0;
	}

	.footer-btns {
		box-shadow: 3px 5px 8px #787878;
		padding: 0 15px;
		height: 60px;
		background-color: #fff;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
</style>
